module.exports = __webpack_public_path__ + "img/plus-gray-16x16.3b5994c4.svg";